export default __webpack_public_path__ + "static/media/1Password.b596cedf.svg";